import { render, staticRenderFns } from "./SpecifyInfo.vue?vue&type=template&id=9c772ce0&scoped=true&"
import script from "./SpecifyInfo.vue?vue&type=script&lang=js&"
export * from "./SpecifyInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpecifyInfo.vue?vue&type=style&index=0&id=9c772ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c772ce0",
  null
  
)

export default component.exports